<template>
  <div class="container-emprendedores">
      <div class="container container-fade">
        <div class="row">

          <div class="col-12 col-md-5 offset-md-1 align-self-center d-md-none d-block text-center">
            <div>
              <img width="80%" :src="`${publicPath}assets/images/emprendedor.png`" />
            </div>
          </div>

          <div class="col-12 col-md-6 align-self-center">
            <div class="linea mt-5 mb-3">
              <h2 class="mb-3">{{ article.story.emprendedores.title }}</h2>
            </div>
            <div class="row">
              <div class="col-12">
                <div v-html="article.story.emprendedores.descripcion"></div>
              </div>

              <div class="col-12 col-md-12">
                <div class="text-center mt-3 linea mb-3">
                </div>
              </div>


            </div>
          
          </div>
          <div class="col-12 col-md-5 offset-md-1 align-self-center d-none d-md-block">
            <div>
              <img width="100%" :src="`${publicPath}assets/images/emprendedor.png`" />
            </div>
          </div>

        </div>

        <div class="row">
          <div class="col-12 col-md-8">
            <NominadosList :nominados="nominados" />
          </div>          
        </div>
      </div> 

    </div>
</template>


<script>

import filter from 'lodash/filter'

import NominadosList from '@/components/NominadosList'

export default {
  name: 'Emprendedores',
  props: {
    nominados_list: []
  },
  data () {
    return {
      publicPath: process.env.BASE_URL
    }
  },
  components: {
    NominadosList
  },
  computed: {
    article() {
      return require(`@/i18n/es.json`)
    },
    nominados() {
      return filter(this.nominados_list, ['category_id', 'emprendedores'])
    }
  }
}
</script>
